export enum ImageViewMode {
    Flat = 'flat',
    Arched = 'arched',
}
